import { render } from "./AfterTest.vue?vue&type=template&id=825c2f78&scoped=true"
import script from "./AfterTest.vue?vue&type=script&lang=js"
export * from "./AfterTest.vue?vue&type=script&lang=js"

import "./AfterTest.vue?vue&type=style&index=0&id=825c2f78&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825c2f78"]])

export default __exports__